import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AdminRoute } from "@/components/AdminRoute";
import { Layout } from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ManageUsersPage from "@/pages/ManageUsersPage";
import PropertiesPage from "@/pages/PropertiesPage";
import PropertyFormPage from "@/pages/PropertyFormPage";
import PropertyDetailPage from "@/pages/PropertyDetailPage";
import LeadsPage from "@/pages/LeadsPage";
import LeadFormPage from "@/pages/LeadFormPage";
import LeadDetailPage from "@/pages/LeadDetailPage";
import DealsPage from "@/pages/DealsPage";
import DealPage from "@/pages/DealPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/properties" element={<PropertiesPage />} />
            <Route path="/properties/new" element={<AdminRoute><PropertyFormPage /></AdminRoute>} />
            <Route path="/properties/:id" element={<PropertyDetailPage />} />
            <Route path="/properties/:id/edit" element={<AdminRoute><PropertyFormPage /></AdminRoute>} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/leads/new" element={<AdminRoute><LeadFormPage /></AdminRoute>} />
            <Route path="/leads/:id" element={<LeadDetailPage />} />
            <Route path="/leads/:id/edit" element={<AdminRoute><LeadFormPage /></AdminRoute>} />
            <Route path="/deals" element={<DealsPage />} />
            <Route path="/deals/:id" element={<DealPage />} />
            <Route
              path="/users"
              element={
                <AdminRoute>
                  <ManageUsersPage />
                </AdminRoute>
              }
            />
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
